import axios from 'axios';
import { apiPath as backendPath } from '../../config/apiBaseUrl';


export const getArticles = async (searchOptions) => {
  const getArticleUrls = `${backendPath}charlee-accolades`;
  try {
    const response = await axios.get(getArticleUrls, {
      params: searchOptions, // Pass searchOptions as query parameters
    });
    return response.data; // Return the data from the response
  } catch (error) {
    console.error("Error fetching articles:", error);
    throw error; // Re-throw the error for further handling
  }
};

export const getArticleById = async (id) => {
  const getArticleUrl = `${backendPath}charlee-accolades/${id}`;
  try {
    const response = await axios.get(getArticleUrl);
    return response.data;
  } catch (error) {
    console.error("Error fetching article by id:", error);
    throw error;
  }
};